/**
 * IceCube Jewelry Customizer
 * A vanilla JavaScript implementation of the jewelry customizer
 */

document.addEventListener('DOMContentLoaded', function() {
  const customizer = document.getElementById('ice-dazzle-customizer');
  if (!customizer) return;
  
  const app = document.getElementById('ice-dazzle-customizer-app');
  const loadingElement = customizer.querySelector('.ice-dazzle-loading');
  
  // Get product data from data attributes
  const productData = {
    id: customizer.dataset.productId,
    title: customizer.dataset.productTitle,
    handle: customizer.dataset.productHandle,
    variantId: customizer.dataset.productVariantId,
    currency: customizer.dataset.shopCurrency || 'USD',
    metafieldsEnabled: customizer.dataset.metafieldsEnabled === 'true',
    basePrice: parseFloat(customizer.dataset.basePrice || '0')
  };
  
  // Default options and configurations
  let customizations = {
    band: 'platinum',
    setting: 'solitaire',
    style: 'classic',
    color: 'ice-blue',
    carat: '1.0'
  };
  
  // Options data - these will be used if metafields are not enabled
  let bands = [
    { id: 'platinum', label: 'Platinum', image: '' },
    { id: 'white-gold', label: 'White Gold', image: '' },
    { id: 'rose-gold', label: 'Rose Gold', image: '' },
    { id: 'yellow-gold', label: 'Yellow Gold', image: '' }
  ];
  
  let settings = [
    { id: 'solitaire', label: 'Solitaire', description: 'A single diamond takes center stage' },
    { id: 'halo', label: 'Halo', description: 'Small diamonds encircle the center stone' },
    { id: 'three-stone', label: 'Three Stone', description: 'Three diamonds symbolizing past, present and future' },
    { id: 'side-stone', label: 'Side Stone', description: 'Additional diamonds along the band' }
  ];
  
  let styles = [
    { id: 'classic', label: 'Classic', description: 'Timeless elegance that never goes out of style' },
    { id: 'vintage', label: 'Vintage', description: 'Inspired by designs from bygone eras' },
    { id: 'modern', label: 'Modern', description: 'Contemporary designs with clean lines' },
    { id: 'minimalist', label: 'Minimalist', description: 'Sleek simplicity with understated beauty' }
  ];
  
  let colors = [
    { id: 'white', color: '#f9fafb', label: 'White', description: 'Traditional colorless diamond' },
    { id: 'ice-blue', color: '#7dd3fc', label: 'Ice Blue', description: 'Our signature arctic blue hue' },
    { id: 'pink', color: '#fbcfe8', label: 'Pink', description: 'Romantic rose-tinted diamond' },
    { id: 'yellow', color: '#fde68a', label: 'Yellow', description: 'Warm golden-hued diamond' },
    { id: 'green', color: '#a7f3d0', label: 'Green', description: 'Rare and distinctive green diamond' }
  ];
  
  let carats = [
    { id: '0.5', label: '0.5 Carat', description: 'Delicate and understated', price: 0 },
    { id: '1.0', label: '1.0 Carat', description: 'The perfect balance of presence and elegance', price: 1000 },
    { id: '1.5', label: '1.5 Carat', description: 'Bold and eye-catching', price: 2500 },
    { id: '2.0', label: '2.0 Carat', description: 'Luxurious statement piece', price: 4000 }
  ];

  // If metafields are enabled, load customizer options from metafields
  if (productData.metafieldsEnabled) {
    try {
      const metafieldOptions = JSON.parse(document.getElementById('icecube-customizer-options').textContent);
      
      // Load options from metafields if available
      if (metafieldOptions.bands && metafieldOptions.bands.length > 0) {
        bands = metafieldOptions.bands;
        customizations.band = bands[0].id; // Set default to first option
      }
      
      if (metafieldOptions.settings && metafieldOptions.settings.length > 0) {
        settings = metafieldOptions.settings;
        customizations.setting = settings[0].id;
      }
      
      if (metafieldOptions.styles && metafieldOptions.styles.length > 0) {
        styles = metafieldOptions.styles;
        customizations.style = styles[0].id;
      }
      
      if (metafieldOptions.colors && metafieldOptions.colors.length > 0) {
        colors = metafieldOptions.colors;
        customizations.color = colors[0].id;
      }
      
      if (metafieldOptions.carats && metafieldOptions.carats.length > 0) {
        carats = metafieldOptions.carats;
        customizations.carat = carats[0].id;
      }
      
      console.log('Loaded customizer options from metafields:', metafieldOptions);
    } catch (error) {
      console.error('Error loading options from metafields:', error);
    }
  }

  // Pricing calculations
  function calculatePrice() {
    // If metafields are enabled, use more dynamic price calculation
    if (productData.metafieldsEnabled) {
      let totalPrice = productData.basePrice;
      
      // Band material pricing
      const selectedBand = bands.find(b => b.id === customizations.band);
      if (selectedBand && selectedBand.price) {
        totalPrice += parseFloat(selectedBand.price);
      }
      
      // Setting type pricing
      const selectedSetting = settings.find(s => s.id === customizations.setting);
      if (selectedSetting && selectedSetting.price) {
        totalPrice += parseFloat(selectedSetting.price);
      }
      
      // Style pricing
      const selectedStyle = styles.find(s => s.id === customizations.style);
      if (selectedStyle && selectedStyle.price) {
        totalPrice += parseFloat(selectedStyle.price);
      }
      
      // Color pricing
      const selectedColor = colors.find(c => c.id === customizations.color);
      if (selectedColor && selectedColor.price) {
        totalPrice += parseFloat(selectedColor.price);
      }
      
      // Carat pricing
      const selectedCarat = carats.find(c => c.id === customizations.carat);
      if (selectedCarat && selectedCarat.price) {
        totalPrice += parseFloat(selectedCarat.price);
      }
      
      return totalPrice;
    } else {
      // Use the original hardcoded pricing for backward compatibility
      const basePrice = 3000;
      
      // Band material pricing
      const bandPrices = {
        'platinum': 1200,
        'white-gold': 800,
        'rose-gold': 900,
        'yellow-gold': 850
      };
      
      // Setting type pricing
      const settingPrices = {
        'solitaire': 400,
        'halo': 700,
        'three-stone': 900,
        'side-stone': 800
      };
      
      // Find selected carat price
      const selectedCarat = carats.find(c => c.id === customizations.carat);
      const caratPrice = selectedCarat && selectedCarat.price ? selectedCarat.price : 0;
      
      return basePrice + 
        (bandPrices[customizations.band] || 0) + 
        (settingPrices[customizations.setting] || 0) + 
        caratPrice;
    }
  }
  
  // Helper function to format price
  function formatPrice(price) {
    return price.toLocaleString(undefined, {
      style: 'currency',
      currency: productData.currency
    });
  }
  
  // Generate a mock product image URL based on customizations
  function getProductImageUrl() {
    return `https://placekitten.com/500/500?v=${Date.now()}`;
  }
  
  // Create UI elements for the customizer
  function renderUI() {
    // Show app container and hide loading message
    app.style.display = 'block';
    loadingElement.style.display = 'none';
    
    // Create container for customizer content
    const content = document.createElement('div');
    
    // Create preview section
    const previewSection = document.createElement('div');
    previewSection.className = 'ice-dazzle-preview';
    
    const previewImage = document.createElement('img');
    previewImage.src = getProductImageUrl();
    previewImage.alt = productData.title + ' preview';
    previewSection.appendChild(previewImage);
    
    // Create tabs for different customization options
    const tabsContainer = document.createElement('div');
    tabsContainer.className = 'ice-dazzle-tabs';
    
    const tabContents = document.createElement('div');
    tabContents.className = 'ice-dazzle-tab-contents';
    
    // Create tabs for different customization types
    const tabTypes = [
      { id: 'band', label: 'Band Material' },
      { id: 'setting', label: 'Setting Type' },
      { id: 'style', label: 'Ring Style' },
      { id: 'color', label: 'Diamond Color' },
      { id: 'carat', label: 'Carat Weight' }
    ];
    
    // Create each tab
    tabTypes.forEach((tabType, index) => {
      // Create tab button
      const tab = document.createElement('div');
      tab.className = `ice-dazzle-tab ${index === 0 ? 'active' : ''}`;
      tab.dataset.tab = tabType.id;
      tab.textContent = tabType.label;
      tabsContainer.appendChild(tab);
      
      // Create tab content
      const tabContent = document.createElement('div');
      tabContent.className = `ice-dazzle-tab-content ${index === 0 ? 'active' : ''}`;
      tabContent.dataset.tabContent = tabType.id;
      
      // Create option group
      const optionGroup = document.createElement('div');
      optionGroup.className = 'ice-dazzle-option-group';
      
      const optionsContainer = document.createElement('div');
      optionsContainer.className = 'ice-dazzle-options';
      
      // Populate options based on the tab type
      let options = [];
      
      switch(tabType.id) {
        case 'band':
          options = bands;
          options.forEach(option => {
            const optionEl = document.createElement('div');
            optionEl.className = 'ice-dazzle-option';
            
            const button = document.createElement('button');
            button.className = `ice-dazzle-option-button ${option.id === customizations.band ? 'selected' : ''}`;
            button.dataset.optionType = tabType.id;
            button.dataset.optionValue = option.id;
            button.textContent = option.label;
            
            optionEl.appendChild(button);
            optionsContainer.appendChild(optionEl);
          });
          break;
        
        case 'setting':
          options = settings;
          options.forEach(option => {
            const optionEl = document.createElement('div');
            optionEl.className = 'ice-dazzle-option';
            
            const button = document.createElement('button');
            button.className = `ice-dazzle-option-button ${option.id === customizations.setting ? 'selected' : ''}`;
            button.dataset.optionType = tabType.id;
            button.dataset.optionValue = option.id;
            button.textContent = option.label;
            
            const description = document.createElement('small');
            description.style.display = 'block';
            description.style.marginTop = '0.5rem';
            description.style.fontSize = '0.7rem';
            description.style.textAlign = 'center';
            description.style.color = '#6b7280';
            description.textContent = option.description;
            
            optionEl.appendChild(button);
            optionEl.appendChild(description);
            optionsContainer.appendChild(optionEl);
          });
          break;
        
        case 'style':
          options = styles;
          options.forEach(option => {
            const optionEl = document.createElement('div');
            optionEl.className = 'ice-dazzle-option';
            
            const button = document.createElement('button');
            button.className = `ice-dazzle-option-button ${option.id === customizations.style ? 'selected' : ''}`;
            button.dataset.optionType = tabType.id;
            button.dataset.optionValue = option.id;
            button.textContent = option.label;
            
            const description = document.createElement('small');
            description.style.display = 'block';
            description.style.marginTop = '0.5rem';
            description.style.fontSize = '0.7rem';
            description.style.textAlign = 'center';
            description.style.color = '#6b7280';
            description.textContent = option.description;
            
            optionEl.appendChild(button);
            optionEl.appendChild(description);
            optionsContainer.appendChild(optionEl);
          });
          break;
        
        case 'color':
          options = colors;
          options.forEach(option => {
            const optionEl = document.createElement('div');
            optionEl.className = 'ice-dazzle-option';
            
            const swatch = document.createElement('div');
            swatch.className = `ice-dazzle-color-swatch ${option.id === customizations.color ? 'selected' : ''}`;
            swatch.style.backgroundColor = option.color;
            swatch.dataset.optionType = tabType.id;
            swatch.dataset.optionValue = option.id;
            
            const label = document.createElement('small');
            label.style.display = 'block';
            label.style.marginTop = '0.5rem';
            label.style.fontSize = '0.7rem';
            label.style.textAlign = 'center';
            label.textContent = option.label;
            
            optionEl.appendChild(swatch);
            optionEl.appendChild(label);
            optionsContainer.appendChild(optionEl);
          });
          break;
        
        case 'carat':
          options = carats;
          options.forEach(option => {
            const optionEl = document.createElement('div');
            optionEl.className = 'ice-dazzle-option';
            
            const button = document.createElement('button');
            button.className = `ice-dazzle-option-button ${option.id === customizations.carat ? 'selected' : ''}`;
            button.dataset.optionType = tabType.id;
            button.dataset.optionValue = option.id;
            button.textContent = option.label;
            
            const description = document.createElement('small');
            description.style.display = 'block';
            description.style.marginTop = '0.5rem';
            description.style.fontSize = '0.7rem';
            description.style.textAlign = 'center';
            description.style.color = '#6b7280';
            description.textContent = option.description;
            
            optionEl.appendChild(button);
            optionEl.appendChild(description);
            optionsContainer.appendChild(optionEl);
          });
          break;
      }
      
      optionGroup.appendChild(optionsContainer);
      tabContent.appendChild(optionGroup);
      tabContents.appendChild(tabContent);
    });
    
    // Create price display and add to cart button
    const priceDisplay = document.createElement('div');
    priceDisplay.style.marginTop = '2rem';
    priceDisplay.style.marginBottom = '1rem';
    priceDisplay.style.textAlign = 'center';
    priceDisplay.style.fontSize = '1.2rem';
    priceDisplay.style.fontWeight = 'bold';
    priceDisplay.id = 'customizer-price';
    priceDisplay.textContent = formatPrice(calculatePrice());
    
    const addToCartButton = document.createElement('button');
    addToCartButton.id = 'customizer-add-to-cart';
    addToCartButton.style.display = 'block';
    addToCartButton.style.width = '100%';
    addToCartButton.style.marginTop = '1rem';
    addToCartButton.style.padding = '0.75rem 1.5rem';
    addToCartButton.style.backgroundColor = '#0891b2';
    addToCartButton.style.color = 'white';
    addToCartButton.style.border = 'none';
    addToCartButton.style.borderRadius = '4px';
    addToCartButton.style.fontSize = '1rem';
    addToCartButton.style.fontWeight = 'bold';
    addToCartButton.style.cursor = 'pointer';
    addToCartButton.textContent = 'Add Customized Product to Cart';
    
    // Assemble UI components
    content.appendChild(previewSection);
    content.appendChild(tabsContainer);
    content.appendChild(tabContents);
    content.appendChild(priceDisplay);
    content.appendChild(addToCartButton);
    
    // Add everything to the app container
    app.appendChild(content);
    
    // Add event listeners
    addEventListeners();
  }
  
  // Handle option selection
  function handleOptionSelection(optionType, optionValue) {
    // Store the selected option in our customizations object
    customizations[optionType] = optionValue;
    
    // Update UI to reflect selected option
    if (optionType === 'color') {
      // Update color swatches
      const swatches = document.querySelectorAll('.ice-dazzle-color-swatch');
      swatches.forEach(swatch => {
        if (swatch.dataset.optionType === optionType) {
          if (swatch.dataset.optionValue === optionValue) {
            swatch.classList.add('selected');
          } else {
            swatch.classList.remove('selected');
          }
        }
      });
    } else {
      // Update option buttons
      const buttons = document.querySelectorAll('.ice-dazzle-option-button');
      buttons.forEach(button => {
        if (button.dataset.optionType === optionType) {
          if (button.dataset.optionValue === optionValue) {
            button.classList.add('selected');
          } else {
            button.classList.remove('selected');
          }
        }
      });
    }
    
    // Update price display
    const priceDisplay = document.getElementById('customizer-price');
    if (priceDisplay) {
      priceDisplay.textContent = formatPrice(calculatePrice());
    }
    
    // Update preview image
    const previewImage = document.querySelector('.ice-dazzle-preview img');
    if (previewImage) {
      previewImage.src = getProductImageUrl();
    }
  }
  
  // Add event listeners to interactive elements
  function addEventListeners() {
    // Tab navigation
    const tabs = document.querySelectorAll('.ice-dazzle-tab');
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        // Remove active class from all tabs and contents
        document.querySelectorAll('.ice-dazzle-tab').forEach(t => t.classList.remove('active'));
        document.querySelectorAll('.ice-dazzle-tab-content').forEach(c => c.classList.remove('active'));
        
        // Add active class to clicked tab and corresponding content
        this.classList.add('active');
        const tabContent = document.querySelector(`[data-tab-content="${this.dataset.tab}"]`);
        if (tabContent) {
          tabContent.classList.add('active');
        }
      });
    });
    
    // Option buttons
    const optionButtons = document.querySelectorAll('.ice-dazzle-option-button');
    optionButtons.forEach(button => {
      button.addEventListener('click', function() {
        handleOptionSelection(this.dataset.optionType, this.dataset.optionValue);
      });
    });
    
    // Color swatches
    const colorSwatches = document.querySelectorAll('.ice-dazzle-color-swatch');
    colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', function() {
        handleOptionSelection(this.dataset.optionType, this.dataset.optionValue);
      });
    });
    
    // Add to cart button
    const addToCartButton = document.getElementById('customizer-add-to-cart');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', addToCart);
    }
  }
  
  // Add to cart functionality
  function addToCart() {
    // Get customization properties to add to the cart
    const properties = {
      'Band': bands.find(b => b.id === customizations.band).label,
      'Setting': settings.find(s => s.id === customizations.setting).label,
      'Style': styles.find(s => s.id === customizations.style).label,
      'Color': colors.find(c => c.id === customizations.color).label,
      'Carat': carats.find(c => c.id === customizations.carat).label
    };
    
    // Create the line item with the selected variant and properties
    const item = {
      id: productData.variantId,
      quantity: 1,
      properties: properties
    };
    
    // Use Shopify's AJAX API to add to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [item]
      })
    })
    .then(response => response.json())
    .then(data => {
      // Show success message
      const successMessage = document.createElement('div');
      successMessage.style.backgroundColor = '#a7f3d0';
      successMessage.style.color = '#064e3b';
      successMessage.style.padding = '1rem';
      successMessage.style.borderRadius = '4px';
      successMessage.style.marginTop = '1rem';
      successMessage.style.textAlign = 'center';
      successMessage.textContent = 'Your customized ring has been added to the cart!';
      
      customizer.appendChild(successMessage);
      
      // Remove the message after 3 seconds
      setTimeout(() => {
        customizer.removeChild(successMessage);
      }, 3000);
      
      // Refresh mini-cart if it exists
      if (typeof window.refreshCart === 'function') {
        window.refreshCart();
      } else {
        // If no refreshCart function exists, reload the page
        window.location.href = '/cart';
      }
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      
      // Show error message
      const errorMessage = document.createElement('div');
      errorMessage.style.backgroundColor = '#fecaca';
      errorMessage.style.color = '#7f1d1d';
      errorMessage.style.padding = '1rem';
      errorMessage.style.borderRadius = '4px';
      errorMessage.style.marginTop = '1rem';
      errorMessage.style.textAlign = 'center';
      errorMessage.textContent = 'There was an error adding your customized ring to the cart.';
      
      customizer.appendChild(errorMessage);
      
      // Remove the message after 3 seconds
      setTimeout(() => {
        customizer.removeChild(errorMessage);
      }, 3000);
    });
  }
  
  // Initialize the customizer
  renderUI();
});
